import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: "timeRemaining",
})
export class TimeRemainingPipe implements PipeTransform {
  transform(totalSeconds: number, numberClass: string) {
      const days = Math.floor(totalSeconds / 86400);
      totalSeconds %= 86400;

      const hours = Math.floor(totalSeconds / (3600));
      totalSeconds %= 3600;

      const minutes = Math.floor(totalSeconds / 60);

      const seconds = totalSeconds % 60;

      return `<span class="${numberClass}">${days}</span> <i>DAYS</i> : <span class="${numberClass}">${hours}</span> <i>HOURS</i> : <span class="${numberClass}">${minutes}</span> <i>MINS</i> : <span class="${numberClass}">${seconds}</span> <i>SECS</i>`;
  }
}



// WEBPACK FOOTER //
// ./src/app/_pipes/time-remaining.pipe.ts